import * as React from 'react';
import { Link } from 'react-router-dom';
import { STATIC_STORAGE_URL } from '@nexxt/common/constants';

const PageNotFound = ({ message }) => {
    const defaultText = () => {
        return (
            <>
                Unfortunately, this page does not exist. If you’re looking for a
                dashboard, are you sure you’ve{` `}
                <b>launched the project?</b>
            </>
        );
    };
    return (
        <div className="error-message--container --border">
            <div className="error-message">
                <div className="error-message--header">
                    <img
                        className="error-message--header--image"
                        src={`${STATIC_STORAGE_URL}/img/404-ghost.png`}
                    />
                    <div className="error-message--header--title">
                        Sorry Researcher, page not found.
                    </div>
                </div>
                <div className="error-message--body">
                    {message || defaultText()}
                </div>
                <div className="error-message--actions">
                    <Link
                        className="error-message--actions--button --blue"
                        to="/"
                    >
                        Go to home
                    </Link>
                </div>
            </div>
        </div>
    );
};
export default PageNotFound;
